var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhotoGray = function SvgPhotoGray(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "34px",
    viewBox: "0 0 42 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,12.3970588 C16.8756932,12.3970588 13.9772727,15.2331029 13.9772727,18.7794118 C13.9772727,22.3257206 16.8756932,25.1617647 20.5,25.1617647 C24.1243068,25.1617647 27.0227273,22.3257206 27.0227273,18.7794118 C27.0227273,15.2331029 24.1243068,12.3970588 20.5,12.3970588 L20.5,12.3970588 Z M20.5,8.75 C26.1388977,8.75 30.75,13.2618676 30.75,18.7794118 C30.75,24.2969559 26.1388977,28.8088235 20.5,28.8088235 C14.8611023,28.8088235 10.25,24.2969559 10.25,18.7794118 C10.25,13.2618676 14.8611023,8.75 20.5,8.75 L20.5,8.75 Z M14.9090909,1 L12.5795455,5.55882353 L3.26136364,5.55882353 C1.45456818,5.55882353 0,6.98208824 0,8.75 L0,28.8088235 C0,30.5767353 1.45456818,32 3.26136364,32 L37.7386364,32 C39.5454318,32 41,30.5767353 41,28.8088235 L41,8.75 C41,6.98208824 39.5454318,5.55882353 37.7386364,5.55882353 L28.4204545,5.55882353 L26.0909091,1 L14.9090909,1 Z",
    id: "photo-gray_path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.2%",
    y: "-1.6%",
    width: "104.9%",
    height: "106.5%",
    filterUnits: "objectBoundingBox",
    id: "photo-gray_filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#photo-gray_path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#BDCFE1",
    fillRule: "evenodd",
    xlinkHref: "#photo-gray_path-1"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhotoGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo_gray.f9e7e266.svg";
export { ForwardRef as ReactComponent };